<template>
  <ConfigView />
  <CalendarAssistant />
  <DoorMapEditor />
  <BulmaDrawer header="Vorschau" :opening="store.update" refreshable>
    <UserView />
  </BulmaDrawer>
</template>

<script setup lang="ts">
import { advent22Store } from "@/lib/store";

import UserView from "../UserView.vue";
import BulmaDrawer from "../bulma/Drawer.vue";
import CalendarAssistant from "./CalendarAssistant.vue";
import ConfigView from "./ConfigView.vue";
import DoorMapEditor from "./DoorMapEditor.vue";

const store = advent22Store();
</script>
